import React from 'react'
import { useDesk } from '../deskContext'

export default function MarketTicker({ headlines = [] }) {
  const desk = useDesk()
  if (!headlines.length) return null
  const loop = [...headlines, ...headlines]

  return (
    <div
      className="w-full overflow-hidden border-y"
      style={{ backgroundColor: 'var(--onds-surface)', borderColor: 'var(--onds-border)' }}
    >
      <div className="flex whitespace-nowrap onds-marquee py-2">
        {loop.map((headline, i) => (
          <span key={i} className="flex items-center text-sm text-[var(--onds-text-dim)]">
            <span className="mx-3 font-semibold" style={{ color: 'var(--onds-accent)' }}>{desk.ticker}</span>
            <span>{headline}</span>
            <span className="mx-4" style={{ color: 'var(--onds-border)' }}>|</span>
          </span>
        ))}
      </div>
    </div>
  )
}
